<template>
    <v-layout align-start>
        <v-flex>
            <v-app id="inspire" v-if="TablaVisible == 0">
                <v-card max-width="1200">
                    <v-container>
                        <v-toolbar color="primary" dark>

                            <v-icon>savings</v-icon>
                            <v-spacer></v-spacer>

                            <v-toolbar-title>Pago de Creditos</v-toolbar-title>
                            <v-spacer></v-spacer>

                            <v-btn icon @click="mostrarNuevo()">
                                <v-icon>add</v-icon>
                            </v-btn>

                        </v-toolbar>
                        <v-row>

                            <v-col cols="12" sm="6" md="6" class="pa-3">
                                <v-card>
                                    <v-card-title>Adeudo Total</v-card-title>
                                    <v-card-text>
                                        <h1 class="text-md-center">
                                            {{ calcularTotal }}
                                        </h1>

                                    </v-card-text>

                                </v-card>
                            </v-col>

                            <v-col cols="12" sm="6" md="6" class="pa-3">
                                <v-card>
                                    <v-card-title>Abono</v-card-title>
                                    <v-card-text>
                                        <h1 class="text-md-center">
                                            {{ calcularabono }}
                                        </h1>

                                    </v-card-text>

                                </v-card>
                            </v-col>

                            <v-col cols="12" sm="6" md="6" class="pa-3">
                                <v-select v-model="clienteid" :items="clienteselect" label="Cliente" outlined
                                    v-on:change="listarcreditovigente()"></v-select>
                            </v-col>

                            <v-col cols="12" sm="6" md="6" class="pa-3">
                                <v-select v-model="creditoformadepago" :items="creditoformadepagoselect"
                                    label="Forma de Pago" outlined v-on:change="listarcreditovigente()"></v-select>
                            </v-col>
                        </v-row>

                        <v-card-title class="pa-0">
                            <v-row>
                                <v-col cols="12" sm="12" md="12" class="pa-3">
                                    <v-text-field v-model="search" append-icon="mdi-magnify"
                                        label="Busca por Ticket, Vale, Factura Etc." outlined
                                        hide-details></v-text-field>
                                </v-col>
                            </v-row>
                        </v-card-title>

                        <v-data-table v-model="selected" :headers="headers" :items="creditovigenteselect"
                            :single-select="singleSelect" :search="search" item-key="creditoid" show-select
                            class="elevation-1 pa-0">
                            <template v-slot:top>
                                <v-switch v-model="singleSelect" label="Seleccionar Todos" class="pa-3"></v-switch>
                            </template>

                            <template v-slot:item.creditoestatus="{ item }">
                                <v-chip :color="getColor(item.creditoestatus)" dark>
                                    SIN PAGO
                                </v-chip>
                            </template>

                        </v-data-table>
                    </v-container>
                </v-card>
            </v-app>

        </v-flex>
    </v-layout>
</template>

<script>
import axios from "axios";
import moment from "moment";
import VueExcelXlsx from "vue-excel-xlsx";

export default {
    data() {
        return {
            guardarvisible: 0,
            TablaVisible: 0,
            fecha1: moment(this.$store.state.usuario.fecha, "YYYY-MM-DD").format("YYYY-MM-DD"),
            fecha2: moment(this.$store.state.usuario.fecha, "YYYY-MM-DD").format("YYYY-MM-DD"),
            modal: false,
            modal1: false,
            menu: false,
            modal: false,
            clienteid: "",
            clientenombre: "",
            clienteselect: [],
            guardarvisiblesino: 0,
            guardarditasino: 0,
            creditoadeudototal: 0,
            singleSelect: false,
            selected: [],
            headers: [
                { text: 'Id', value: 'creditoid' },
                { text: 'Fecha', value: 'creditofecha' },
                { text: 'Magna', value: 'magna' },
                { text: 'Diesel', value: 'premium' },
                { text: 'Premium', value: 'diesel' },
                { text: 'Ticket', value: 'creditoticket' },
                { text: 'Vale', value: 'creditovale' },
                { text: 'Importe', value: 'creditoimporte' },
                { text: 'Estatus', value: 'creditoestatus' },
            ],
            search: "",
            creditovigenteselect: [],
            creditoformadepago: 0,
            creditoformadepagoselect: [
                { text: "SELECCIONE FORME DE PAGO", value: 0 },
                { text: "EFECTIVO", value: 1 },
                { text: "TRANSFERENCIA", value: 2 },
                { text: "CHEQUE", value: 3 },
                { text: "EFECTIVO-TRANSFERENCIA", value: 4 },
                { text: "EFECTIVO-CHEQUE", value: 5 },
                { text: "OTRA FORMA DE PAGO", value: 6 },
            ],
        };
    },
    // Crea una nueva categoria si es -1
    computed: {
        calcularTotal: function () {
            var resultado = 0.0;
            for (var i = 0; i < this.creditovigenteselect.length; i++) {
                resultado = resultado + parseFloat(this.creditovigenteselect[i].creditoimporte)
            }
            return new Intl.NumberFormat('es-MX', { style: 'currency', currency: 'MXN' }).format(resultado,);
        },
        calcularabono: function () {
            var resultado = 0.0;
            for (var i = 0; i < this.selected.length; i++) {
                resultado = resultado + parseFloat(this.selected[i].creditoimporte)
            }
            return new Intl.NumberFormat('es-MX', { style: 'currency', currency: 'MXN' }).format(resultado,);
        }
    },

    watch: {

    },

    created() {
        this.clientecredito();
    },

    //
    methods: {
        getHumanDate: function (date) {
            return moment(date, "YYYY-MM-DD").format("DD/MM/YYYY");
        },

        getColor(creditoestatus) {
            return 'red'
        },

        clientecredito() {
            let me = this;
            var listaArray = [];
            let header = { Authorization: this.$store.state.token };
            let configuracion = { headers: header };
            axios
                .get("api/clientes/listarempresa/" + 1, configuracion)
                .then(function (response) {
                    me.liquidaselect = [];
                    listaArray = response.data.cliente;
                    listaArray.map(function (x) {
                        me.clienteselect.push({
                            text: x.clientenombre,
                            value: x.clienteigas
                        });
                    });
                })
                .catch(function (error) {
                    console.log(error);
                    if (error.response.data.code == 400) {
                        me.$swal("La Sesión a Expirado");
                        me.$store.dispatch("salir");
                    }
                });
        },

        mostrarNuevo() {
            this.TablaVisible = 1;
            this.guardarvisiblesino = 0;
            this.limpiar();
        },

        ocultarNuevo() {
            this.TablaVisible = 0;
            this.limpiar();
        },


        guardar() {

            let header = { Authorization: this.$store.state.token };
            let configuracion = { headers: header };
            let me = this;

            let formData = new FormData();

            formData.append("clienteid", me.clienteid);
            formData.append("combustibleid", me.combustibleid);
            formData.append("creditoimporte", me.creditoimporte);
            formData.append("creditofecha", me.creditofecha);
            formData.append("creditoticket", me.creditoticket);
            formData.append("creditovale", me.creditovale);
            formData.append("creditofactura", me.creditofactura);
            formData.append("creditousuariocaptura", me.$store.state.usuario.usuarioid);
            formData.append("file0", me.file);
            formData.append("movimientoid", me.movimientoid);
            formData.append("liquidacionid", me.liquidacionid);
            formData.append("servicioid", me.servicioid);

            axios
                .post(
                    "api/creditos/crear",
                    formData,
                    configuracion
                )
                .then(function (response) {
                    me.limpiar();
                    me.listar();
                    me.TablaVisible = 0;
                    me.$swal("Flete Capturado con Exito");
                })
                .catch(function (error) {
                    console.log(error);
                    if (error.response.data.code == 400) {
                        me.$swal("La Sesión a Expirado");
                        me.$store.dispatch("salir");
                    }
                });
        },

        close() {
            this.TablaVisible = 0;
            this.fleteexcel = 0;
        },

        limpiar() {
            this.creditofecha = moment(this.$store.state.usuario.fecha, "YYYY-MM-DD").format("YYYY-MM-DD"),
                this.clienteid = "";
            this.clientenombre = "";
        },

        

        listarcreditovigente() {
            // Variable para cargar los datos del api
            let me = this;
            let header = { Authorization: this.$store.state.token };
            let configuracion = { headers: header };
            // Manda llamar al listado e catalogos
            axios
                .get("api/creditos/creditosporcliente/" + me.clienteid, configuracion)
                .then(function (response) {
                    me.creditovigenteselect = response.data.credito; 
                })
                .catch(function (error) {
                    console.log(error);
                    if (error.response.data.code == 400) {
                        me.$swal("La Sesión a Expirado");
                        me.$store.dispatch("salir");
                    }
                });
        },

    }
};
</script>